<template>
  <layout-dashboard>
    <h1 class="header center grey-text text-darken-3">{{ msg }}</h1>
    <div class="row">
      <router-link :to="{ name: item.target }" class="col s12 m6" v-for="(item, index) in object" :key="index">
        <div class="card button-action-card hoverable" :style="{'background-image': 'url(' + item.backgoundImage + ')'}">
          <div class="row button-action-row waves-effect waves-block waves-light" :style="{'background-color': item.backgoundColor}">
            <div class="col s4 center button-action-icon" v-html="item.icon">
            </div>
            <div class="col s8 center button-action-text" v-html="item.text">
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </layout-dashboard>
</template>

<script>
import LayoutDashboard from '@/components/layouts/Dashboard'
export default {
  name: 'hello',
  data () {
    return {
      msg: '¿Que deseas hacer?',
      object: [
        {
          icon: '<i class="fas fa-money-check"></i>',
          text: 'Generar Recibo de Pago',
          backgoundImage: '/static/img/button-background-01.png',
          backgoundColor: 'rgba(239, 83, 80, 0.8)',
          target: 'recibo'
        },
        {
          icon: '<i class="fas fa-file-invoice"></i>',
          text: 'Generar Constancia de Trabajo',
          backgoundImage: '/static/img/button-background-02.png',
          backgoundColor: 'rgba(216, 67, 21, 0.8)',
          target: 'constancia'
        },
        {
          icon: '<i class="fas fa-hand-holding-usd"></i>',
          text: 'Comprobante de retención ISLR<br><small>(En Construcción)</small>',
          backgoundImage: '/static/img/button-background-03.png',
          backgoundColor: 'rgba(174, 174, 174, 0.8)',
          target: 'home'
        }
      ]
    }
  },
  mounted () {
    document.title = 'RRHH Gobernación de Yaracuy'
  },
  components: {
    LayoutDashboard
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  body {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
  }

  main {
    flex: 1 0 auto;
  }
.headband {
  padding: 2px 0;
  img {
    max-height: 44px;
  }
  .row {
    margin-bottom: 0;
  }
}
.button-action-card {
  background-position: center;
  background-size: cover;
}
.button-action-row {
  display: flex;
  margin: 0px;
  min-height: 200px;
}
.button-action-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 90px;
  color: #ffffff;
  i {
    font-size: 90px;
  }
}
.button-action-text {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: #ffffff;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue